import { Action } from 'redux';

export const HEADER_SEARCH_KEYDOWN = 'HEADER_SEARCH_KEYDOWN';

export interface SearchKeyDownAction extends Action {
  key: string;
}
export const keyDown = (key: string) => ({
  type: HEADER_SEARCH_KEYDOWN,
  key
});
